<template>
    <div
        :class="['payment-layout__tabs', { '-no-steps-header': !showStepsHeader }]"
        role="tablist"
        aria-orientation="horizontal">
        <template v-if="featurePaypal && featureFlagPaypal">
            <a
                class="tab qt-cctab"
                role="tab"
                id="tab-cards"
                :aria-selected="activeTab === tab.cc ? 'true' : 'false'"
                aria-controls="panel-cards"
                tabindex="1"
                @keydown.enter.prevent="handleEnterKey"
                @click="handleClickTab($event, tab.cc)"
                aria-label="Credit Card">
                <CreditCardLogos :cards="this.acceptedCards" />
            </a>
            <a
                class="tab tab--payPal qt-paypaltab"
                role="tab"
                id="tab-paypal"
                :aria-selected="activeTab === tab.payPal ? 'true' : 'false'"
                aria-controls="panel-paypal"
                tabindex="1"
                @keydown.enter.prevent="handleEnterKey"
                @click="handleClickTab($event, tab.payPal)"
                aria-label="PayPal"></a>
            <div :class="tabIndicatorClass"></div>
        </template>
        <template v-else>
            <div
                class="tab qt-cctab"
                role="tab"
                id="tab-cards"
                :aria-selected="'true'"
                aria-controls="panel-cards"
                tabindex="1"
                aria-label="Credit Card">
                <CreditCardLogos :cards="this.acceptedCards" />
            </div>
            <div :class="tabIndicatorClass"></div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CreditCardLogos from 'aa/vue/components/CreditCardLogos';
    import { ACTION_NAMES, tracking } from 'services/Tracking';
    import { SKIP_EXPLAINER_STEPS } from 'aa/helpers/featureConstants';
    // START TEST PLOCTOPLUS-1915: center align payment page
    import CenterAlignPaymentPageAbTest from 'aa/vue/abTestRelated/CenterAlignPaymentPageAbTest';
    // END TEST PLOCTOPLUS-1915: center align payment page
    import { TAB } from 'aa/vue/FormConfig';

    export default {
        name: 'PaymentTabsContainer',
        mixins: [CenterAlignPaymentPageAbTest],
        components: {
            CreditCardLogos,
        },
        props: {
            activeTab: {
                type: String,
                default: TAB.cc,
            },
            isEditPayment: {
                type: Boolean,
                default: false,
            },
            pageTypeForTracking: {
                type: String,
                default: '',
            },
        },
        data: function () {
            return {
                featurePaypal: false,
                featureFlagPaypal: false,
                acceptedCards: [],
            };
        },
        mounted() {
            this.featurePaypal = this.$store.state.serverData.paymentMethods?.paypal.enabled;
            this.acceptedCards = this.$store.state.serverData.paymentMethods?.acceptedCreditCards;
            this.featureFlagPaypal = this.$store.state.serverData?.paypalAvailableInCountry;
        },
        computed: {
            ...mapGetters(['featureIsActive']),
            hasSkipExplainers() {
                return this.featureIsActive(SKIP_EXPLAINER_STEPS);
            },
            showStepsHeader() {
                if (this.$store.state.serverData.hideStepsHeader) {
                    return false;
                }

                return !this.isEditPayment && !this.hasSkipExplainers;
            },
            tabIndicatorClass() {
                return [
                    'active-indicator',
                    {
                        'active-indicator--payPal': this.activeTab === TAB.payPal,
                    },
                    { '-no-steps-header': !this.showStepsHeader },
                ];
            },
            tab() {
                return TAB;
            },
            trackingService() {
                return this.$trackingService ?? tracking;
            },
            pageType() {
                if (this.pageTypeForTracking) {
                    return this.pageTypeForTracking;
                }
                let pageType = !this.isEditPayment ? 'svod_payment' : 'account_switchpayment';
                return pageType;
            },
        },
        methods: {
            handleEnterKey(e) {
                e.target.click();
            },
            handleClickTab(e, tabId) {
                e.preventDefault();
                this.$emit('update:activeTab', tabId);

                this.trackingService.trackAction(ACTION_NAMES.PAYMENT_METHOD_SELECTED, {
                    ctaText: tabId,
                    pageType: this.pageType,
                });
            },
        },
    };
</script>
